import { Link } from "react-router-dom";

const assetUrl = (u) => (!u ? "" : u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`);

const formatDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getDate()} ${d.toLocaleString("en-GB", { month: "long" })} ${d.getFullYear()}`;
};

/**
 * Reusable article card. Used on the homepage strip, the /resources listing,
 * and the "Related Articles" section on single article pages.
 */
export default function ArticleCard({ article, testid }) {
  const image = assetUrl(article.featured_image);
  const dateStr = formatDate(article.publish_date || article.created_at);
  return (
    <Link
      to={`/resources/${article.slug}`}
      className="article-card"
      data-testid={testid || `article-card-${article.slug}`}
    >
      <div className="article-card-media">
        {image ? (
          <img src={image} alt={article.title} loading="lazy" />
        ) : (
          <div className="article-card-media-placeholder" aria-hidden />
        )}
      </div>
      <div className="article-card-body">
        {article.category && (
          <div className="article-card-category">{article.category}</div>
        )}
        <h3 className="article-card-title">{article.title}</h3>
        {article.excerpt && (
          <p className="article-card-excerpt">{article.excerpt}</p>
        )}
        <div className="article-card-meta">
          {dateStr && <span>{dateStr}</span>}
          <span className="article-card-read-more">
            Read More
            <svg width="14" height="10" viewBox="0 0 18 12" fill="none" aria-hidden>
              <path d="M1 6h15M11 1l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        </div>
      </div>
    </Link>
  );
}
